import bizNodeModel from '../../bizNodeModel.mjs'
import SrcType from '../components/SrcType.mjs'
import UiruleType from './UiruleType.jsx'

export default bizNodeModel({
    srcType: {
        name: () => '来源类型',

        readableValue: (map, node) => {
            const {srcType} = node.data

            if (srcType) {
                const match = SrcType.find(e => srcType === e[0])

                if (match) {
                    return match[1]
                }
            }

            return ''
        },
    },

    ruleKey: {
        name: () => '规则关键字',
    },

    ruleTitle: {
        name: () => '规则标题',
        required: () => true,
    },

    ruleType: {
        name: () => '规则类型',

        readableValue: (map, node) => {
            const {ruleType} = node.data

            if (ruleType) {
                const match = UiruleType.find(e => ruleType === e[0])

                if (match) {
                    return match[1]
                }
            }

            return ''
        },
    },

    ruleUserCode: {
        name: () => '规则代码',
    },
})
